import React from "react";

import { Text } from "@ui/Atoms";

import { Markdown } from "@containers/Markdown";

import { useTranslate } from "@hooks/useTranslate";

import { Group } from "../Group";
import { FooterLink } from "../FooterLink";

import * as Styled from "./Cities.styled";

export const Cities: React.FC = () => {
  const translate = useTranslate("batmaid_pwa_footer");
  const locations = translate("locations");
  const coming_soon = translate("coming_soon");

  if (!locations) return null;

  return (
    <Group title={translate("locations_header")}>
      <Styled.Root>
        <Markdown
          components={{
            a: props => <FooterLink {...props} />,
          }}
        >
          {locations}
        </Markdown>
      </Styled.Root>
      {coming_soon && (
        <Text $style="regular_14" $color="white">
          {coming_soon}
        </Text>
      )}
    </Group>
  );
};
